import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Routes from './routers/routes';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import injectTapEventPlugin from 'react-tap-event-plugin';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {
    blue800,
    blue500,
    white,
    lightBlack,
    darkBlack,
    grey300
} from 'material-ui/styles/colors';
import Spacing from 'material-ui/styles';
import {configureStore} from './store';
import {Provider} from 'react-redux';
import root from './saga';
import {syncHistoryWithStore} from 'react-router-redux';
import createBrowserHistory from 'history/createBrowserHistory';
import {persistStore} from 'redux-persist';
import {asyncSessionStorage} from 'redux-persist/storages'
import moment from 'moment';
import {randomColor} from 'randomcolor';
import * as actions from './actions';
import * as srv from './services';
import './index.css';
import 'antd/dist/antd.css';
import registerServiceWorker from './services/ServiceWorker';

injectTapEventPlugin();

export const store = configureStore();
store.runSaga(root);

const history = syncHistoryWithStore(createBrowserHistory(), store);

const muiTheme = getMuiTheme({
    spacing: Spacing,
    fontFamily: 'Roboto, sans-serif',
    palette: {
        primary1Color: blue800,
        primary2Color: blue500,
        primary3Color: lightBlack,
        textColor: darkBlack,
        alternateTextColor: white,
        canvasColor: white,
        borderColor: grey300
    }
});

let customProjects = [{
    id: 63,
    name: 'BẢO TRÌ THIẾT BỊ',
    description: 'bảo hành, bảo trì thiết bị iTracking',
    logo: 'http://itracking.vn/images/logo.png',
    logoName: 'iTracking'
},
    {
        id: 65,
        name: 'SMARTBIKE - BẢO TRÌ THIẾT BỊ',
        description: 'bảo hành, bảo trì thiết bị SmartBike',
        logo: 'http://smartbike.vn/public/images/Ui-new/logo_smartbike.png',
        logoName: ''
    }];

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rehydrated: false
        };
    }

    componentWillMount() {
        //Raven.config('http://788aa32dabe549579a059a73445f335b@sentry.dinhviso.com.vn:9000/6').install();
        persistStore(store, {
            storage: asyncSessionStorage,
            whitelist: ["token", "account"],
        }, async () => {
            let state = store.getState();
            if (state.token && state.token.length > 0) {
                await this.initData(state.token);
            }

            this.setState({rehydrated: true})
        })
    }


    async initData(token) {
        const query = 'read/' + customProjects[0].id;
        const dataUsers = await srv.readUsers(query);
        if (dataUsers.users) {
            dataUsers.users.map((user) => {
                if (!user.color) {
                    user.color = randomColor({luminosity: 'dark'});
                }
            });
        }

        let now = moment();
        let strNow = now.format('DD-MM-YYYY');
        const dataIssues = await srv.getAllIssues(customProjects[0].id, token, 'week', strNow);
        if (dataIssues.status === 401) {
            alert("Đã hết phiên làm việc, vui lòng đăng nhập lại!");
            store.dispatch(actions.removeToken());
        }

        store.dispatch(actions.setProjects(customProjects));
        store.dispatch(actions.setCurrentProject(customProjects[0].id));

        store.dispatch(actions.getIssuesMap(dataIssues.issues ? dataIssues.issues : []));
        store.dispatch(actions.setNotis(dataIssues.notifications ? dataIssues.notifications : []));
        store.dispatch(actions.setNotiCount(dataIssues.notiCount ? dataIssues.notiCount : 0));

        store.dispatch(actions.selectUserMap(dataUsers.users));

        store.dispatch(actions.getOverviewByTrackers(dataIssues.trackers ? dataIssues.trackers : []));
        store.dispatch(actions.getTrackersMap(dataIssues.trackers ? dataIssues.trackers : []));
    }

    render() {
        return this.state.rehydrated ?
            <Provider store={store}>
                <MuiThemeProvider muiTheme={muiTheme}>
                    <Routes historyBrowser={history}/>
                </MuiThemeProvider>
            </Provider>
            :
            <div style={{
                display: 'table',
                margin: 'auto',
                paddingTop: '25%'
            }}>
                <div style={{
                    display: 'block',
                    float: 'left'
                }}>
                </div>
                <div className={'spinner'}>
                    <div className={'rect1'}></div>
                    <div className={'rect2'}></div>
                    <div className={'rect3'}></div>
                    <div className={'rect4'}></div>
                    <div className={'rect5'}></div>
                </div>
            </div>
    }
}

ReactDOM.render(
    <Home/>, document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js